const EIGHT_D_PRINT_STYLES = `
  @page { size: A4 portrait; margin: 10mm; }
  * { box-sizing: border-box; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  html, body { margin: 0; padding: 0; height: auto; overflow: visible; }
  body { font-family: Arial, Helvetica, sans-serif; font-size: 10px; color: #212529; background: #fff; }
  .eight-d-print .grid { border-collapse: collapse; width: 100%; }
  .eight-d-print .grid th, .eight-d-print .grid td { border: 1px solid #6c757d; padding: 4px 6px; vertical-align: top; }
  .eight-d-print .banner {
    background: #1e3a5f; color: #fff; text-align: center; font-weight: 700; font-size: 14px;
    padding: 8px; margin-bottom: 8px;
  }
  .eight-d-print .section { color: #1e3a5f; font-weight: 700; font-size: 11px; margin: 10px 0 4px; text-transform: uppercase; }
  .eight-d-print .hint { font-size: 9px; color: #495057; margin-bottom: 4px; line-height: 1.3; }
  .eight-d-print .head { background: #1e3a5f; color: #fff; font-weight: 700; }
  .eight-d-print img { max-width: 200px; max-height: 160px; object-fit: contain; page-break-inside: avoid; }
  .eight-d-print figure { page-break-inside: avoid; margin: 0; }
  .eight-d-print-page + .eight-d-print-page { page-break-before: always; break-before: page; }
`;

export function printEightDReport(rootEl, documentTitle = '8D-Report') {
    if (!rootEl || !rootEl.innerHTML) {
        window.alert('Nothing to print yet.');
        return;
    }

    const safeTitle = String(documentTitle).replace(/[<>&"]/g, '');
    const contentHtml = rootEl.innerHTML;

    const iframe = document.createElement('iframe');
    iframe.setAttribute('title', '8D print');
    iframe.setAttribute('style', 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden');
    document.body.appendChild(iframe);

    const win = iframe.contentWindow;
    const doc = win.document;
    doc.open();
    doc.write(`<!doctype html><html lang="en"><head><meta charset="utf-8" /><title>${safeTitle}</title>
<style>${EIGHT_D_PRINT_STYLES}</style></head><body>${contentHtml}</body></html>`);
    doc.close();

    const cleanup = () => {
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    };

    const runPrint = () => {
        try {
            win.focus();
            win.print();
        } catch (e) {
            cleanup();
            window.alert('Print failed. Please try again.');
        }
    };

    if (win.onafterprint !== undefined) win.onafterprint = cleanup;
    else setTimeout(cleanup, 2000);

    const images = doc.images;
    if (!images || images.length === 0) {
        setTimeout(runPrint, 150);
        return;
    }

    let loaded = 0;
    const tryPrint = () => {
        loaded += 1;
        if (loaded >= images.length) setTimeout(runPrint, 100);
    };
    Array.from(images).forEach((img) => {
        if (img.complete) tryPrint();
        else {
            img.addEventListener('load', tryPrint);
            img.addEventListener('error', tryPrint);
        }
    });
}
